import { Box } from '@mui/material'
import { WorkCentreSummaryTable } from './WorkCentreSummary.table'
import { Loader } from 'Common/Loader/Loader'
import { useParams, useNavigate } from 'react-router-dom'
import {
  usePublishedWorkcentres,
  useWorkcentreList,
} from './WorkCentreSummary.data'
import { useEffect, useState } from 'react'
import {
  WorkcentrePublishedDialogProps,
  WorkCentreSummaryTableData,
} from './WorkCentreSummary.types'
import { usePublishSOROperationalPlan } from 'Features/OperationalPlanner/SystemOfRecords/SOROperationalPlans.data'
import toast from 'react-hot-toast'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'
import { Button } from 'Common/Supplyvue-ui'

const WorkcentrePublishedDialog = ({
  open,
  handleClose,
  handleClickYes,
}: WorkcentrePublishedDialogProps) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{'Publish workcentres'}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {`Publishing plans will make the plan read-only and overwrite any plans previously published for the same work centres. Do you want to proceed ?`}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClickYes}>Yes</Button>
        <Button onClick={handleClose} autoFocus>
          No
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export const OverviewView = () => {
  const { planId } = useParams<{ planId: string }>()
  const { data, isLoading } = useWorkcentreList(planId)
  const { data: publishedWorkcentresForThePlanStartWeek } =
    usePublishedWorkcentres(planId)
  const navigate = useNavigate()

  const [isPublishedWorkcentreDialogOpen, setIsPublishedWorkcentreDialogOpen] =
    useState(false)
  const [selectedWorkcentres, setSelectedWorkcentres] = useState<
    WorkCentreSummaryTableData[] | []
  >([])

  const onPublishSuccess = () => {
    toast.success('Workcentres published successfully')
    navigate(`/`)
  }

  const onPublishError = () => {
    toast.error('Failed to publish workcentres')
  }

  const { mutate: publishWorkcentres, isLoading: isPublishing } =
    usePublishSOROperationalPlan(onPublishSuccess, onPublishError)

  const handlePublishWorkcentres = (
    workcentres: WorkCentreSummaryTableData[]
  ) => {
    setSelectedWorkcentres(workcentres)
    setIsPublishedWorkcentreDialogOpen(true)
  }

  const handleClickYes = () => {
    setIsPublishedWorkcentreDialogOpen(false)
    const dataToServer = selectedWorkcentres.map(
      (workcentre: WorkCentreSummaryTableData) => ({
        workCentreKey: workcentre.workCentreKey,
      })
    )
    publishWorkcentres({
      planId,
      workcentres: dataToServer,
    })
  }

  return (
    <Box id="overview-tab-panel-box">
      <WorkCentreSummaryTable
        isLoading={isLoading}
        data={data?.data ?? []}
        planId={planId}
        handlePublishWorkcentres={handlePublishWorkcentres}
        isPublishing={isPublishing}
        planAccess={data?.planAccess ?? {}}
      />
      <WorkcentrePublishedDialog
        open={isPublishedWorkcentreDialogOpen}
        handleClose={() => setIsPublishedWorkcentreDialogOpen(false)}
        week={publishedWorkcentresForThePlanStartWeek?.plan_start_week ?? ''}
        handleClickYes={handleClickYes}
      />
    </Box>
  )
}
